module.exports = __webpack_public_path__ + "img/banner.b17eb641.png";